import { Badge } from '@/components/ui/badge';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import React from 'react';

export function StudyGuideLessonDataGrid(props) {
  const { data, height = 'auto' } = props;

  return (
    <div
      className="overflow-y-auto"
      style={{ height: height }}
    >
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead scope="col">Nome da aula</TableHead>
            <TableHead
              scope="col"
              className="w-28 text-right"
            >
              Matéria
            </TableHead>
          </TableRow>
        </TableHeader>

        <TableBody>
          {data?.map((item, key) => (
            <TableRow key={key}>
              <TableHead scope="row">
                <span
                  className="truncate"
                  title={item.name}
                >
                  {item.name}
                </span>
              </TableHead>
              <TableCell className="text-right">
                {item.taxonomies[0] ? (
                  <Badge
                    size="xs"
                    title={item.taxonomies[0]}
                  >
                    {item.taxonomies[0]}
                  </Badge>
                ) : (
                  <span className="text-neutral-400">-</span>
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
